module.exports = __webpack_public_path__ + "static/media/restaurant.1275e841.svg";